import { Table, Skeleton } from 'antd';

import { Error403Unauthorized } from '@app/components';
import {
  FORBIDDEN_ERROR_MAIN_PART,
  ORGANIZATION_USERS_TABLE_HEADER,
  PREFIX,
  U_KEY,
} from '@app/constants';
import { useAccessToOrganizations } from '@app/hooks';
import { OrganizationUsersFilters } from '@app/pages/Organizations/OrganizationUsers/components';
import { adaptDataToTable } from '@app/pages/Organizations/OrganizationUsers/utils/adaptDataToTable';

import { useOrganizationUsers } from '@pages/Organizations/OrganizationUsers/hooks/useOrganizationUsers';

import '@app/pages/Organizations/OrganizationUsers/styles/OrganizationUsers.desktop.scss';

export const OrganizationUsers = () => {
  const { data, isLoading, pageNumber, rowsPerPage, change, setRequestData } =
    useOrganizationUsers();

  const { areRightsToOrganizationsModule } = useAccessToOrganizations();

  if (!areRightsToOrganizationsModule) {
    return <Error403Unauthorized title={`${FORBIDDEN_ERROR_MAIN_PART}.`} />;
  }

  if (isLoading) {
    return <Skeleton active />;
  }

  return (
    <div className={`${PREFIX}organization-users`}>
      <OrganizationUsersFilters setRequestData={setRequestData} />
      <Table
        dataSource={adaptDataToTable(data?.Data ?? [])}
        columns={ORGANIZATION_USERS_TABLE_HEADER}
        rowKey={(record) => String(record[U_KEY])}
        rowClassName="user-item"
        pagination={{
          size: 'default',
          showSizeChanger: true,
          total: data?.Total,
          pageSize: rowsPerPage,
          position: ['bottomLeft'],
          current: pageNumber,
          onChange: change,
          showTotal: (total, range) =>
            `Показаны ${range[0]}-${range[1]} из ${total}`,
        }}
      />
    </div>
  );
};
